import { AuthErrorClass } from "./types";

// Supabase refresh-session error codes that mean the session itself is dead (the
// refresh token revoked or used, the session expired or the user banned), so the
// person must be signed out. Anything else (network, timeout, rate limit, unknown)
// is transient and must NEVER sign the user out (spec §3.3). `session_not_found`
// never arrives as a code: auth-js 2.118 turns it into AuthSessionMissingError,
// whose code is undefined, and the callers read that name.
const GENUINE_SUPABASE_CODES = new Set([
  "refresh_token_not_found",
  "invalid_grant",
  "refresh_token_already_used",
  "session_expired",
  "user_banned",
]);

/** Classifies a Supabase refresh-session failure by its error code. */
export const classifyAuthError = (code?: string): AuthErrorClass =>
  code && GENUINE_SUPABASE_CODES.has(code)
    ? AuthErrorClass.GENUINE
    : AuthErrorClass.TRANSIENT;
